module.exports = __webpack_public_path__ + "static/media/next.e0506584.svg";